let estimatedShippingTimeout;

async function getProductTags(handle) {
  try {
    const response = await fetch(`/products/${handle}.js`);
    const product = await response.json();
    return product.tags || [];
  } catch (error) {
    console.log('Kunne ikke hente tags:', handle, error);
    return [];
  }
}

function normalizeTag(tag) {
  return String(tag || '').trim().toLowerCase();
}

function hasTag(cartTags, tag) {
  return cartTags.includes(normalizeTag(tag));
}

function formatPrice(price) {
  return `${price},00 kr.`;
}

async function loadEstimatedShipping() {
  const wrapper = document.querySelector('[data-estimated-shipping]');
  if (!wrapper) return;

  clearTimeout(estimatedShippingTimeout);

  estimatedShippingTimeout = setTimeout(async () => {
    try {
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();

      if (!cart.items || !cart.items.length) {
        wrapper.innerHTML = 'Fragt beregnes i checkout';
        return;
      }

      const totalWeight = cart.total_weight;

      const handles = [...new Set(cart.items.map(item => item.handle))];
      const tagArrays = await Promise.all(handles.map(getProductTags));
      const cartTags = [...new Set(tagArrays.flat().map(normalizeTag))];

      let shippingPrice = null;

      /*
      Prioritet:
      Dyreste / mest restriktive fragt først.
      Derfor ligger afhentning nederst.
      */

if (hasTag(cartTags, 'pallet_only') || totalWeight > 20000) {
  shippingPrice = totalWeight <= 50000 ? 398 : 399;

} else if (hasTag(cartTags, 'parcel_home')) {
  shippingPrice = 399;

} else if (hasTag(cartTags, 'dropship')) {
  shippingPrice = 198;

} else if (hasTag(cartTags, 'kungls')) {
  shippingPrice = totalWeight <= 19990 ? 59 : 89;

} else if (hasTag(cartTags, 'afhentning')) {
  shippingPrice = 0;

} else {
  if (totalWeight <= 4990) {
    shippingPrice = 59;
  } else if (totalWeight <= 9990) {
    shippingPrice = 69;
  } else if (totalWeight <= 14990) {
    shippingPrice = 79;
  } else if (totalWeight <= 20000) {
    shippingPrice = 89;
  } else if (totalWeight <= 50000) {
    shippingPrice = 398;
  } else {
    shippingPrice = 399;
  }
}

      wrapper.innerHTML = `
        Estimeret fragt fra <strong>${formatPrice(shippingPrice)}</strong><br>
        <small>Fragtprisen er vejledende. Endelig fragtpris beregnes, når adressen er indtastet i kassen.</small>
      `;

      console.log('Cart weight:', totalWeight);
      console.log('Cart tags:', cartTags);
      console.log('Estimated shipping:', shippingPrice);

    } catch (error) {
      console.log('Estimated shipping error:', error);
      wrapper.innerHTML = 'Fragt beregnes i checkout';
    }
  }, 300);
}

loadEstimatedShipping();

document.addEventListener('cart:updated', loadEstimatedShipping);
document.addEventListener('cart:refresh', loadEstimatedShipping);
document.addEventListener('cart-drawer:open', loadEstimatedShipping);

const observer = new MutationObserver(() => {
  if (document.querySelector('[data-estimated-shipping]')) {
    loadEstimatedShipping();
  }
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});